

























































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

@Component({
	name: 'EditInfo',
	components: {},
})
export default class EditInfo extends Vue {
	@Prop()
	private title!: any // 模块标题 主要用于校验错误提示
	@Prop()
	private list!: any
	@Prop()
	private span!: any
	@Prop({
		default: 'small',
	})
	private size?: string

	private listTemp: any[] = []

	@Watch('list', { deep: true })
	private onInfoSetChange(v: any[]) {
		this.listTemp = v.slice()
	}

	// 表单校验组装
	private get requiredForm() {
		let form: any = {}
		this.listTemp.forEach((item: any) => {
			form[item.key] = item.value
		})
		return form
	}

	private mounted() {
		this.onInfoSetChange(this.list)
	}

	private getRules(item: any) {
		let rules = [
			{
				required: item.notNull == '1',
				message: `${item.label}不能为空`,
				trigger:
					item.type == 'date' || item.type == 'datetime'
						? ['change']
						: ['blur'],
			},
		]
		if (item.rules) {
			rules = rules.concat(item.rules)
		}
		return rules
	}

	//清除校验
	private resetValidate() {
		;(this.$refs['requiredForm'] as any).resetFields()
	}

	private initPlaceholder(item: any, tips: string) {
		return item.canEdit ? (item.tips ? item.tips : tips) : ''
	}

	private selectSearch(val: any, key: any) {
		this.$emit('selectSearch', val, key)
	}

	private dropdownVisibleChange(val: any, key: any, listTemp: any) {
		this.$emit('dropdownVisibleChange', val, key, listTemp)
	}

	private selectChange(val: any, key: any, listTemp: any) {
		this.$emit('selectChange', val, key, listTemp)
	}

	private inputChange(val: any, key: any, listTemp: any, item: any) {
		this.$emit('inputChange', val, key, listTemp, item)
	}

	// 校验表单
	public validateFormData() {
		let flag = true
		;(this.$refs['requiredForm'] as any).validate(
			(valid: boolean, object: any) => {
				if (!valid) {
					// 做错误提示
					const arr = Object.keys(object)
					if (arr.length > 0) {
						const rules = object[arr[0]]
						if (rules.length > 0) {
							this.$message.error(`${this.title}-${rules[0].message}`)
						}
					}
					flag = false
					return false
				} else {
					flag = true
				}
			}
		)
		return flag
	}

	// 获取表单数据
	public getFormData() {
		return this.requiredForm
	}
}
